import React, { forwardRef } from 'react';

import { ReactComponent as Arrow } from 'assets/icons/ic_arrow.svg';
import dayjs from 'dayjs';
import DatePicker from 'react-datepicker';

const getDayClassName = (date: Date) => {
  const day = dayjs(date).day(); // 0 (일요일)부터 6 (토요일)까지 반환
  if (day === 0 || day === 6) {
    return 'weekend-day'; // 토요일 또는 일요일인 경우 'weekend-day' 클래스 추가
  }
  return ''; // 다른 요일은 기본 클래스
};

interface DatePickerInputProps {
  selectedDate: Date | null;
  setSelectedDate: (date: Date | null) => void;
  hideInput?: boolean;
  isDisabled?: boolean;
  minDate?: Date;
}
const CustomInput = forwardRef<HTMLInputElement, { value?: string; onClick?: () => void }>(
  ({ value = '', onClick }, ref) => (
    <div className="relative flex w-56 shrink-0 flex-col gap-y-2">
      <span className="text-c2">Date</span>
      <input
        ref={ref}
        value={value.toUpperCase()}
        onClick={onClick}
        readOnly
        className="flex h-11 w-full min-w-0 rounded bg-gray-20 p-2.5 text-c2 placeholder:text-gray-30 focus:outline-none"
        placeholder="Select date"
      />
    </div>
  ),
);

CustomInput.displayName = 'CustomInput';

const DatePickerInput = ({ selectedDate, setSelectedDate, hideInput, isDisabled, minDate }: DatePickerInputProps) => {
  const today = dayjs();
  return (
    <DatePicker
      inline={hideInput}
      selected={selectedDate}
      onSelect={setSelectedDate}
      dayClassName={getDayClassName}
      calendarStartDay={1}
      minDate={minDate ? minDate : today.toDate()}
      disabled={isDisabled}
      dateFormat={'MMM dd yyyy'}
      customInput={<CustomInput />}
      renderCustomHeader={({
        date,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
      }) => (
        <div className="flex w-full cursor-default flex-col items-center">
          <div className="text-b4 text-primary">{dayjs(date).format('YYYY')}</div>
          <div className="flex w-full items-center justify-between">
            <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
              <Arrow className="rotate-180 text-[#BBBBBB]" width={30} height={30} />
            </button>
            <div className="text-t4">{dayjs(date).format('MMM')}</div>
            <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
              <Arrow className="text-[#BBBBBB]" width={30} height={30} />
            </button>
          </div>
        </div>
      )}
    />
  );
};

export default DatePickerInput;
